// ABOUTME: Confirmation modal for ending a picking job with two confirm options.
// ABOUTME: Provides setPickedToOpen true/false choice via two styled buttons.

import { Box, useTheme } from "@mui/material"
import SHModal from "../../theme/Modal/SHModal"
import Shbutton from "../../theme/buttons/Shbutton"
import { tokens } from "../../../theme";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";

const MConfirmEndPickingJob = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleConfirm = (setPickedToOpen) => {
        props.confirm(setPickedToOpen);
        props.handleClose();
    }

    return(
        <SHModal
            open={props.open}
            onClose={props.handleClose}
        >
            <Box
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1,
                    maxWidth:600,
                }}>
                <Subheading>{props.title}</Subheading>
                <Text center light>{props.subtitle}</Text>
            </Box>
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    textAlign:"center",
                }}
            >
                <Text sx={{ maxWidth: 400, margin: "0 auto", whiteSpace: "normal", wordBreak: "break-word" }}>
                    {props.content ? props.content : t("set_picked_to_open_description")}
                </Text>
            </Box>
            <Box
                component="footer"
                sx={{
                    display:"flex",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    alignItems:"center",
                    paddingRight:3,
                    paddingLeft:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                        paddingLeft:0,
                    }
                }}
            >

                <Shbutton
                    isCancel={true}
                    className={"always-visible"}
                    onClick={(e) => {
                        if(props.stopPropagation) {
                            e.stopPropagation();
                        }
                        props.handleClose();
                    }}
                    color="primary"
                    variant="text"
                    startIcon={<ArrowRightAltIcon/>}
                >
                    {t("cancel")}
                </Shbutton>
                <ButtonGroup version={2}>
                    <Shbutton
                        className={"group-btn"}
                        color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                        onClick={(e) => {
                            if(props.stopPropagation) {
                                e.stopPropagation();
                            }
                            handleConfirm(false);
                        }}
                        variant="contained"
                    >
                        {t("keep_picked")}
                    </Shbutton>
                    <Shbutton
                        className={"group-btn"}
                        color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        onClick={(e) => {
                            if(props.stopPropagation) {
                                e.stopPropagation();
                            }
                            handleConfirm(true);
                        }}
                        variant="contained"
                    >
                        {t("set_picked_to_open")}
                    </Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MConfirmEndPickingJob;
